export const PlantDesignApplicantDetailsPage = {
  firstNameLabel: 'First name',
  middleNameLabel: 'Middle name(s) (optional)',
  lastNameLabel: 'Last name',
  employerLabel: 'Employer (optional)',
  employerHelpMessage: 'If the organisation you are representing is different to the registration holder',
  jobTitleLabel: 'Job title (optional)',
};
